import { render } from "./App.vue?vue&type=template&id=2eb667d2"
const script = {}

import exportComponent from "H:\\03_微压氧舱-张赟\\共享氧舱\\力氧空间-天康疗养中心\\share-project-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__